import api from "../instance/axios_instance.ts";
import { TraceabilityInterface } from "../interface/traceabilityInterface";

export const GetTraceabilityApi = async (document: number, start_date: string, end_date: string): Promise<TraceabilityInterface[]> => {

    try {
        const response = await api.get('/traceability', {
            params: {
                document: document,
                start_date: start_date,
                end_date: end_date
            }
        });

        return response.data
    }
    catch (error: any) {
        const mensajeError = error?.response?.data?.message;
        throw new Error(mensajeError || 'Error credito');
    }
};